export const TranslatedText = ({ text, children, className }) => {
    return <span className={className}>{text || children}</span>;
};
